import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Schedule from "@/pages/Schedule";
import Records from "@/pages/Records";
import Staff from "@/pages/Staff";
import Documents from "@/pages/Documents";
import Evaluations from "@/pages/Evaluations";
import Organization from "@/pages/Organization";
import Referrers from "@/pages/Referrers";
import SuperAdmin from "@/pages/SuperAdmin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={["super_admin"]}>
                <SuperAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute roles={["tenant_admin", "nurse", "office"]}>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="patients" element={<Patients />} />
            <Route path="patients/:id" element={<PatientDetail />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="records" element={<Records />} />
            <Route path="evaluations" element={<Evaluations />} />
            <Route path="documents" element={<Documents />} />
            <Route path="staff" element={<Staff />} />
            <Route path="referrers" element={<Referrers />} />
            <Route path="organization" element={<Organization />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
